export default __webpack_public_path__ + "static/media/Logo-travel.cd175992.png";